import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-topic-details',
		path: '/admin/topic/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin-topic-details" */ './index'), {
			exportName: 'AdminTopicDetails',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: {
			header: true,
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
